<template>
  <b-overlay
    variant="white"
    :show="isTripStatsLoading"
    spinner-variant="primary"
    blur="0"
    opacity=".75"
    rounded="sm"
  >
    <TripsByZoneModal :service-type="serviceType" />
    <b-row v-if="!isTripStatsLoading">
      <b-col class="d-flex justify-content-between align-items-center">
        <h3 class="text-primary">
          Trips
        </h3>
        <b-button
          variant="flat-primary"
          class="btn-icon rounded-circle mb-1"
          @click="fetchTripsStats"
        >
          <feather-icon
            icon="RefreshCwIcon"
          />
        </b-button>
      </b-col>
      <b-col
        sm="12"
        md="12"
      >
        <TotalTripsTable
          :caption="stats.today.caption"
          :stats="stats.today.normal"
          @click="showTripsByZoneStatsModal"
        />

      </b-col>
      <b-col
        sm="12"
        md="6"
      >
        <TotalTripsTable
          :caption="stats.yesterday.caption"
          :stats="stats.yesterday.normal"
          :till-now="stats.yesterday.tillNow"
          @click="showTripsByZoneStatsModal"
        />
      </b-col>
      <b-col
        sm="12"
        md="6"
      >
        <TotalTripsTable
          :caption="stats.lastweek.caption"
          :stats="stats.lastweek.normal"
          :till-now="stats.lastweek.tillNow"
          @click="showTripsByZoneStatsModal"
        />

      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BRow, BCol, BButton, BOverlay,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import TotalTripsTable from './TotalTripsTable.vue'
import TripsByZoneModal from './TripsByZoneModal.vue'

export default {
  components: {
    TotalTripsTable, BRow, BCol, BButton, BOverlay, TripsByZoneModal,
  },
  props: {
    serviceType: {
      type: String,
      default: undefined,
    },
  },
  setup(props, { root }) {
    const stats = ref({})
    const isTripStatsLoading = ref(false)
    const fetchTripsStats = async () => {
      isTripStatsLoading.value = true
      const res = await root.$store.dispatch('trips/fetchTripsStats', {
        serviceType: props.serviceType,
      })
      stats.value = res.stats
      isTripStatsLoading.value = false
    }
    fetchTripsStats()

    const showTripsByZoneStatsModal = async () => {
      root.$bvModal.show(`${props.serviceType}-trips-by-zone-modal`)
    }
    return {
      stats,
      isTripStatsLoading,
      fetchTripsStats,
      showTripsByZoneStatsModal,
    }
  },
}
</script>

<style scoped>
.trips-stats__wrapper {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}
</style>
